/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi-container/~/lodash/_setToArray.js
// module id = ./node_modules/victory-voronoi-container/node_modules/lodash/_setToArray.js
// module chunks = 1